const testimonials = [
  {
    id: 1,
    name: 'Julie Maguire',
    title: 'Sr Business Systems Consultant',
    org: 'Mutual of Omaha',
    desc: 'Mihir and I worked on a multi-year project to build a valuation/reporting system for insurance products. Mihir developed User Interface functionality and provided testing support. His work was thorough and required collaboration with other developers/testers. I trusted Mihir to use his technical knowledge and skills to develop the best solution possible.',
  },
  {
    id: 2,
    name: 'Soumyadeep Sinha',
    title: 'Software Development Engineer',
    org: 'Amazon',
    desc: 'Mihir and I worked together in the same group to develop a content management website for our coursework. Mihir right from the starting was exceptionally good at System Design and quickly building Infrastructure for the project in AWS. His knowledge and experience in developing web applications using React was also immensly helpful in completing our project on time and deliver a high quality product. He has extensive and diverse knowledge of software, a reliable and highly capable Computer engineer, I can’t recommend him highly enough.',
  },
  {
    id: 3,
    name: 'Suyash Srivastava',
    title: 'Associate Counsel, Product and Commercial, APAC',
    org: 'Uber',
    desc: 'Mihir is a talented computer professional who has a zeal to outperform in his field. I have known him since his undergraduate college days, and even then he was clear on his professional goals. While interning alongside Mihir in AIESEC Mauritius, he undertook extensive efforts as a team leader to help women entrepreneurs on a pro-bono basis to help them build their business online - on website and digital platforms. He was collaborative, approachable and had critical problem solving skills through which he was able to bring change in the lives of some people of Mauritius.',
  },
  {
    id: 4,
    name: 'Dr. Sarah Ghamrawi',
    title: 'Hospital Scientist, PhD',
    org: 'Children’s Cancer Institute',
    desc: 'I met Mihir during an international summer school in France. Mihir stood out, among other group members, as a curious, persevering person, someone who always seeks the best. At the same time he was very polite, respectful of others and sociable. Given the chance, i believe Mihir can acheive a great deal. Best wishes and good luck.',
  },
];
export default testimonials;
